import { EmailPreferencesModel, MaskedAccountInfoModel } from 'src/types/email-preferences.model';
import BWDataService from './bw-data.service';

export default class EmailPreferencesService extends BWDataService {
    public static async getEmailPreferences(): Promise<EmailPreferencesModel> {
        return await this.get('/users/email/settings');
    }

    public static async updateEmailPreferences(emailPreferences: EmailPreferencesModel): Promise<any> {
        return await this.post('/users/email/settings', {
            enableBudgetAlertEmail: emailPreferences.enableBudgetAlertEmail,
            enableMonthlySummaryEmail: emailPreferences.enableMonthlySummaryEmail
        });
    }

    public static async getMaskedAccountInfo(): Promise<MaskedAccountInfoModel> {
        return await this.get('/users/email');
    }
}
